<template>
  <section class="upsell">
    <heading
      :title="title"
      level="h2"
    />
    <div class="upsell__list">
      <Thumbnail v-for="(item, index) in upsells" :key="index" v-bind="item" />
      <slot></slot>
    </div>
  </section>
</template>

<script>
import Heading from '@/components/heading/Heading.vue'
import Thumbnail from '@/components/partials/Thumbnail.vue'

export default {
  components: {
    Thumbnail,
    Heading
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    upsells: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
.upsell {
  &__list {
    padding: $padding;
  }
  &__button {
    margin-top: rem(10);
  }
}

</style>


<docs>
  ```jsx
    <div>
      <News></News>
    </div>
  ```
</docs>
